export const MOBILE_NAVIGATION_BAR_LABELS = [
  'My_devices',
  'Contact_us',
  'My_account',
]
